import "scroll-behavior-polyfill";
import SmoothScroll from "smooth-scroll";
import slick from 'slick-carousel';
import {
  gsap
} from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

//sclickのオプション
import SlickOption from "./class/SlickOption";
//ヘッダー「ENTRY」ボタン動作
import EntryBtn from "./class/EntryBtn";
//valueセクション動作
import ValueBtn from "./class/ValueBtn";
//valueBoxセクション sp動作
import valueBox from "./class/valueBox";
//スクロールイベント
import gsapScroll from "./class/gsapScroll";
//navイベント
import nav from "./class/nav";
//form初期値
import Form_initial from "./class/form_initial";
//リンク系
import LinkOption from "./class/link_option";

// fadeIn
function fadeIn(elm, ms) {
  elm.style.opacity = 0; // 透過度０
  elm.style.display = "block";
  elm.style.transition = "opacity " + ms + "ms";
  setTimeout(function () {
    elm.style.opacity = 1;
  }, 1); // 0.001秒後に transition開始(透過度１にする）
}
// fadeOut
function fadeOut(elm, ms) {
  elm.style.opacity = 1; // 透過度1
  elm.style.transition = "opacity " + ms + "ms";
  setTimeout(function () {
    elm.style.opacity = 0;
  }, 1); // 0.001秒後に transition開始（透過度0にする）
  setTimeout(function () {
    elm.style.display = "none";
  }, ms + 10); // 1.01秒後に完全に消す。
}




window.addEventListener("DOMContentLoaded", () => {
  new SlickOption(); // sclickのオプション
  new EntryBtn(); // ヘッダー「ENTRY」ボタン動作
  new ValueBtn(); // valueセクション動作
  new valueBox(); //valueBoxセクション sp動作
  new gsapScroll(gsap, ScrollTrigger); //
  new nav(fadeIn, fadeOut); //
  new Form_initial(); //
  new LinkOption(SmoothScroll); //
  if(document.querySelector('.mainFade')){
    document.querySelector('.mainFade').classList.add("is_load");
  }
});